<template>
  <div v-if="canAccessPage">

    <grupo-tabela
      style="outline:none;"
      @GRUPOTABELA_EDITAR="editar"
      @GRUPOTABELA_VISUALIZAR="visualizar"/>

  </div>
</template>

<script>
import { generateComputed } from '@/common/functions/roles-computed-generator';
import GrupoTabela from './GrupoTabela';

export default {
  name: 'GrupoList',
  components: {
    GrupoTabela,
  },
  computed: {
    ...generateComputed('Perfil', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
  },
  methods: {
    editar(item) {
      this.$router.push({ name: 'editarGrupo', params: { id: item.id } });
    },
    visualizar(item) {
      this.$router.push({ name: 'verGrupo', params: { id: item.id } });
    },
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast('Acesso negado');
      }
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};
</script>
